import { observable, action, makeAutoObservable, runInAction } from "mobx";
import { message, notification } from "antd";
import { persist } from 'mobx-persist';
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";

class VoterStore {

    @observable loading = false;
    @observable isSuccess = false;

    @observable perPage = 10;
    @observable hasMore = false;
    @observable page = 1;

    @observable perPageCash = 10;
    @observable hasMoreCash = false;
    @observable pageCash = 1;

    @observable perPageItem = 10;
    @observable hasMoreItem = false;
    @observable pageItem = 1;

    @observable voters = [];
    @observable votersAmounts = [];
    @observable votersCashAmounts = [];
    @observable votersItemAmounts = [];

    @observable voter = {};
    @observable votersAmount = {};
    @observable votersCashAmount = {};
    @observable votersItemAmount = {};

    constructor() {
        makeAutoObservable(this);
    }

    @action
    fetchVoters = async () => {
        
        this.loading = true;
        
        try {
            const response = await axios.get(`/voters/get_all_voters.php?perPage=${this.perPage}&page=${this.page}&sortBy=ASC`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        this.voters = response.data.data;
                        if (this.voters && this.voters.length < this.perPage) {
                            this.hasMore = false;
                        } else {
                            this.hasMore = true;
                        }
                    }
                });
            }
        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetching Voters Error',
                    description: error.response.data.message
                });
                message.error('Fetching Voters Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
        
    }

    @action
    fetchVoterByID = async (id) => {
        
        this.loading = true;
        
        try {
            const response = await axios.get(`/voters/get_voter.php?id=${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        this.voter = response.data.data;
                        if (this.voter && this.voter.length < this.perPage) {
                            this.hasMore = false;
                        } else {
                            this.hasMore = true;
                        }
                    }
                });
            }
        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetching Voters Error',
                    description: error.response.data.message
                });
                message.error('Fetching Voters Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
        
    }

    @action
    searchVoters = async (name) => {
        
        this.loading = true;
        
        try {
            const response = await axios.get(`/voters/search_voter.php?name=${name}&perPage=${this.perPage}&page=${this.page}&sortBy=ASC`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        this.voters = response.data.data;
                        if (this.voters && this.voters.length < this.perPage) {
                            this.hasMore = false;
                        } else {
                            this.hasMore = true;
                        }

                        notification.success({
                            top: 120,
                            message: 'Done!',
                            description: 'Search Voter Successful.'
                        });
                    }
                });
            }
        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetching Voters Error',
                    description: error.response.data.message
                });
                message.error('Fetching Voters Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
        
    }

    @action
    searchVotersMultipleData = async (values) => {
        
        this.loading = true;

        const name = values.name == undefined ? "" : values.name;
        const address = values.address == undefined ? "" : values.address;
        const street = values.street == undefined ? "" : values.street;
        const gender = values.gender == undefined ? "" : values.gender;
        const pwd = values.pwd == undefined ? "" : (values.pwd == true ? "Yes" : "No");
        
        try {
            const response = await axios.get(`/voters/search_voter.php?perPage=${this.perPage}&page=${this.page}&sortBy=ASC&name=${name}&address=${address}&street=${street}&sex=${gender}&pwd=${pwd}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        this.voters = response.data.data;
                        if (this.voters && this.voters.length < this.perPage) {
                            this.hasMore = false;
                        } else {
                            this.hasMore = true;
                        }

                        notification.success({
                            top: 120,
                            message: 'Done!',
                            description: 'Search Voter Successful.'
                        });
                    }
                });
            }
        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetching Voters Error',
                    description: error.response.data.message
                });
                message.error('Fetching Voters Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
        
    }

    @action
    fetchVoterAmountByID = async (id) => {

        this.loading = true;
        
        try {
            const response = await axios.get(`/votersamount/get_all_topup_votersamount.php?perPage=${this.perPage}&page=${this.page}&sortBy=DESC&orderBy=CreatedAt&voterID=${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        this.votersAmounts = response.data.data;
                        if (this.votersAmounts && this.votersAmounts.length < this.perPage) {
                            this.hasMore = false;
                        } else {
                            this.hasMore = true;
                        }
                    }
                });
            }

        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetch User Error',
                    description: error.response.data.message
                });
                message.error('Fetch User Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }

    @action
    fetchVoterAmountEventCashByID = async ( eventID, teamLeaderID, status ) => {

        // CURRENTLY EDITTING 07/05/2025
        this.loading = true;
        
        try {

         

            const response = await axios.get(`/events/get_all_events_registration.php?perPage=${this.perPageCash}&page=${this.pageCash}&sortBy=ASC&eventID=${eventID}&teamLeaderID=${teamLeaderID}&status=${status}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                // votersCashAmounts = PENDING
                runInAction(() => {
                    if(response.data){
                        this.votersCashAmounts = response.data.data;
                        if (this.votersCashAmounts && this.votersCashAmounts.length < this.perPageCash) {
                            this.hasMoreCash = false;
                        } else {
                            this.hasMoreCash = true;
                        }
                    }
                });
            }

        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetch User Error',
                    description: error.response.data.message
                });
                message.error('Fetch User Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }

    @action
    fetchVoterAmountEventItemByID = async (eventID, teamLeaderID, status) => {

        this.loading = true;
        
        try {
            const response = await axios.get(`/events/get_all_events_registration.php?perPage=${this.perPageItem}&page=${this.pageItem}&sortBy=ASC&eventID=${eventID}&teamLeaderID=${teamLeaderID}&status=${status}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                // votersItemAmounts = RECEIVED
                runInAction(() => {
                    if(response.data){
                        this.votersItemAmounts = response.data.data;
                        if (this.votersItemAmounts && this.votersItemAmounts.length < this.perPageItem) {
                            this.hasMoreItem= false;
                        } else {
                            this.hasMoreItem = true;
                        }
                    }
                });
            }

        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetch User Error',
                    description: error.response.data.message
                });
                message.error('Fetch User Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }

    @action
    fetchVotersEventRegistrationPendingByName = async ( fullName, status ) => {

        // CURRENTLY EDITTING 07/09/2025
        runInAction(() => {
            this.loading = true;
            this.votersCashAmounts = []; // clear in action so observers see change
        });
        
        try {

            const response = await axios.get(`/events/get_all_events_registration_voter.php?perPage=${this.perPageCash}&page=${this.pageCash}&sortBy=ASC&fullName=${fullName}&status=${status}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                // votersCashAmounts = PENDING na Events Registration
                runInAction(() => {
                    if(response.data){
                        this.votersCashAmounts = response.data.data;
                        if (this.votersCashAmounts && this.votersCashAmounts.length < this.perPageCash) {
                            this.hasMoreCash = false;
                        } else {
                            this.hasMoreCash = true;
                        }
                    }
                });
            }

        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetch User Error',
                    description: error.response.data.message
                });
                message.error('Fetch User Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }

    @action
    fetchVotersEventRegistrationReceivedByName = async ( fullName, status) => {

        runInAction(() => {
            this.loading = true;
            this.votersItemAmounts = []; // clear in action so observers see change
        });
        
        try {
            const response = await axios.get(`/events/get_all_events_registration_voter.php?perPage=${this.perPageItem}&page=${this.pageItem}&sortBy=ASC&fullName=${fullName}&status=${status}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                // votersItemAmounts = RECEIVED na Events Registration
                runInAction(() => {
                    if(response.data){
                        this.votersItemAmounts = response.data.data;
                        if (this.votersItemAmounts && this.votersItemAmounts.length < this.perPageItem) {
                            this.hasMoreItem= false;
                        } else {
                            this.hasMoreItem = true;
                        }
                    }
                });
            }

        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetch User Error',
                    description: error.response.data.message
                });
                message.error('Fetch User Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }

    @action
    fetchVoterAmountTeamLeaderByID = async (id) => {

        this.loading = true;
        
        try {
            const response = await axios.get(`/votersamount/get_all_votersamount_teamleader.php?perPage=${this.perPage}&page=${this.page}&sortBy=DESC&orderBy=CreatedAt&teamLeaderID=${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('QUNDRVNTX1RPS0VO')}`,
                }
            });

            if (response.status === 200) {
                runInAction(() => {
                    if(response.data){
                        this.votersAmounts = response.data.data;
                        if (this.votersAmounts && this.votersAmounts.length < this.perPage) {
                            this.hasMore = false;
                        } else {
                            this.hasMore = true;
                        }
                    }
                });
            }

        } catch (error) {
            if(error.response.data){
                notification.error({
                    top: 120,
                    message: 'Fetch User Error',
                    description: error.response.data.message
                });
                message.error('Fetch User Error');
            }
            runInAction(() => {
                this.isSuccess = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false
            });
        }
    }
}

export default VoterStore;
